import Link from 'next/link'
import toast from 'react-hot-toast'
import { BsCopy, BsQuestionCircle, BsShare } from 'react-icons/bs'
import { FaPatreon } from 'react-icons/fa'
import { MdMailOutline } from 'react-icons/md'
import { getPublicShareUrl } from '../../../helpers/publicShareUrl'

/** Footer action buttons: share, copy link, feedback, guide and Patreon. */
export default function FooterIconPack() {
  /** Opens the system share sheet with the public page URL, or copies it as a fallback. */
  const share = async () => {
    const shareData = {
      title: document.title,
      text: '',
      // Always share the public website URL, even inside the native app.
      url: getPublicShareUrl(window.location.href),
    }

    if (window && window.navigator) {
      try {
        await navigator.share(shareData)
      } catch (_err) {
        copy()
      }
    }
  }

  /** Copies the public page URL to the clipboard. */
  const copy = () => {
    if (window && window.navigator) {
      window.navigator.clipboard.writeText(getPublicShareUrl(window.location.href))
      toast.success('Başarıyla kopyalandı!')
    }
  }
  return (
    <div className="w-full my-2 text-xs flex-center">
      <button
        onClick={share}
        className="w-8 h-8 p-1 mr-2 text-gray-800 bg-gray-200 rounded-full flex-center hover:opacity-50"
        title="Sayfayı Paylaş"
        aria-label="Sayfayı Paylaş"
      >
        <BsShare width={20} />
      </button>
      <button
        onClick={copy}
        className="w-8 h-8 p-1 mr-2 text-gray-800 bg-gray-200 rounded-full flex-center hover:opacity-50"
        title="Bağlantıyı Kopyala"
        aria-label="Bağlantıyı Kopyala"
      >
        <BsCopy width={20} />
      </button>
      <Link
        className="w-8 h-8 p-1 mr-2 text-gray-800 bg-gray-200 rounded-full flex-center hover:opacity-50"
        href="/geri-bildirim"
        title="Geri Bildirim Gönder"
        aria-label="Geri Bildirim Gönder"
      >
        <MdMailOutline width={20} />
      </Link>

      <Link
        href="/rehber"
        className="w-8 h-8 p-1 mr-2 text-gray-800 bg-gray-200 rounded-full flex-center hover:opacity-50"
        title="Uygulama Rehberi"
        aria-label="Uygulama Rehberi"
      >
        <BsQuestionCircle className="w-5 h-5" />
      </Link>

      <a
        href="https://patreon.com/Hayirhah"
        target="_blank"
        rel="noopener noreferrer"
        className="w-8 h-8 p-1 mr-2 text-gray-800 bg-gray-200 rounded-full flex-center hover:opacity-50"
        title="Patreon ile Destek Ol"
        aria-label="Patreon ile Destek Ol"
      >
        <FaPatreon className="w-5 h-5 text-[#FF424D]" />
      </a>
    </div>
  )
}
